module.exports = __webpack_public_path__ + "static/media/institute-22-min.8a324160.webp";